import { render } from "./registration-clinic.vue?vue&type=template&id=334bd2c6&scoped=true"
import script from "./registration-clinic.vue?vue&type=script&lang=js"
export * from "./registration-clinic.vue?vue&type=script&lang=js"

import "./registration-clinic.vue?vue&type=style&index=0&id=334bd2c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334bd2c6"]])

export default __exports__